class WorksSlide {
  constructor(el, opt) {
    this.el = el;
    if ($("." + this.el).length > 0) {
      this.event();
    }
  }
  event() {
    var worksSwiper = new Swiper(".worksSwiper", {
      slidesPerView: 1.3,
      spaceBetween: 10,
      pagination: {
        el: ".workspagination",
        clickable: true,
      },
      navigation: {
        nextEl: ".js-works-next",
        prevEl: ".js-works-prev",
      },
      breakpoints: {
        768: {
          slidesPerView: 3.6,
          spaceBetween: 10,
        }
      },
    });
  }
}